import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import FormControl from "@material-ui/core/FormControl";
import { __t } from "@core/translation/translation";
import { Select } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  select: {
    "& .Mui-disabled": {
      backgroundColor: theme.palette.gray2.main,
      opacity: 0.7,
    },
    color: (props) =>
      !!props.value
        ? [theme.palette.secondary.main, "!important"]
        : [theme.palette.secondary.tint40, "!important"],
    "& option": {
      color: [theme.palette.secondary.main, "!important"],
      "&:first-child": {
        color: [theme.palette.secondary.tint40, "!important"],
      },
    },
  },
}));
export default function NativeSelectComponent(props) {
  const {
    name,
    label,
    value,
    error = null,
    helperText,
    onChange,
    options,
    inputRef,
    placeholder,
    className,
    disabled,
    ...rest
  } = props;
  const classes = useStyles(props);
  return (
    <FormControl
      variant="outlined"
      className={!!className ? className : classes.formControl}
    >
      <Select
        autoComplete
        native
        label={label}
        inputRef={inputRef}
        displayEmpty
        name={name}
        onChange={(e) => onChange(e)}
        value={value}
        className={classes.select}
        disabled={disabled}
      >
        {!!placeholder && <option value="">{placeholder}</option>}
        {options.map((item) => (
          <option key={item.name} value={item.id}>
            {item.name}
          </option>
        ))}
      </Select>
    </FormControl>
  );
}
